module.exports = __webpack_public_path__ + "static/media/frameIn.23c67018.jpg";